<template>
  <div>
    <FlotoActionMenuWrapper ref="actionMenuWrapper">
      <MDropdown ref="dropdownMenu" @show="handleShow">
        <template v-slot:trigger>
          <MIcon name="ellipsis-v" size="lg" class="mx-1 cursor-pointer" />
        </template>
        <template v-slot:menu>
          <MMenu ref="menuContainerRef" class="action-menu">
            <MMenuItem>
              <div id="action-menu-child" @click="blockNumber">
                <MIcon name="ban" class="action-menu-icon" />
                <span class="ml-1 action-menu-text">
                  {{ $tc('block_number') }}
                </span>
              </div>
            </MMenuItem>
          </MMenu>
        </template>
      </MDropdown>
    </FlotoActionMenuWrapper>
  </div>
</template>

<script>
export default {
  name: 'ActionMenu',
  props: {
    resource: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  methods: {
    hide() {
      this.$refs.dropdownMenu.hide()
    },
    handleShow() {
      this.$refs.actionMenuWrapper.updateMenuItems(this)
    },
  },
}
</script>
